import React, { useContext, useEffect, useState } from 'react';
import {
    Modal, ModalHeader, ModalBody, Form, Row, Col,
    FormGroup, Label, Input, Button
} from 'reactstrap';
import Select from 'react-select';
import { AuthContext } from '../../context/AuthContext';
import { ProdutoContext } from '../../context/ProdutoContext';
import { UpdateProdutoType, ProdutoType } from '../../context/hooks/useProduto';

import { CurrencyInput } from '../Form/CurrencyInput';

interface Props {
    isOpen: boolean;
    toggle: () => void;
    conta: UpdateProdutoType | null;
    onUpdated?: () => void;
}

export const EditProdutoModal: React.FC<Props> = ({ isOpen, toggle, conta, onUpdated }) => {
    const { updateProduto } = useContext(ProdutoContext);
    const { objUserTk } = useContext(AuthContext);

    const [form, setForm] = useState<UpdateProdutoType | null>(null);

    useEffect(() => {
        if (isOpen && conta) setForm({ ...conta });
    }, [isOpen, conta]);

    if (!form) return null;

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setForm(prev => prev ? { ...prev, [name]: value } : prev);
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!form) return;
        const ok = await updateProduto({
            ...form,
        });
        if (ok) {
            onUpdated?.();
            toggle();
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} backdrop="static" size="lg">
            <ModalHeader toggle={toggle}>Editar informações do produto</ModalHeader>
            <ModalBody>
                <Form onSubmit={handleSubmit}>
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label className="form-control-label">Nome</Label>
                                <Input
                                    className="form-control-alternative"
                                    type="text"
                                    name="name"
                                    value={form.name}
                                    onChange={onChange}
                                    placeholder="Nome do produto"
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label className="form-control-label">Descrição</Label>
                                <Input
                                    className="form-control-alternative"
                                    type="text"
                                    name="description"
                                    value={form.description}
                                    onChange={onChange}
                                    placeholder="Descrição do produto"
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label className="form-control-label">Valor</Label>
                                <CurrencyInput
                                    name="value"
                                    value={form.value ?? 0}
                                    onValueChange={v => setForm(prev => prev ? { ...prev, value: v } : prev)}
                                    placeholder="R$ 0,00"
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <div className="d-flex justify-content-end mt-3">
                        <Button style={{ background: '#585858', color: '#fff' }} type="submit">Salvar alterações</Button>
                        <Button style={{ background: '#585858', color: '#fff' }} className="ml-2" onClick={toggle}>Cancelar</Button>
                    </div>
                </Form>
            </ModalBody>
        </Modal>
    );
};
export default EditProdutoModal;